import { render, staticRenderFns } from "./expansion-panels.vue?vue&type=template&id=202b6eea&scoped=true"
import script from "./expansion-panels.vue?vue&type=script&lang=ts"
export * from "./expansion-panels.vue?vue&type=script&lang=ts"
import style0 from "./expansion-panels.vue?vue&type=style&index=0&id=202b6eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b6eea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HIcon: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/icons/h-icon.vue').default})
